var $ = global.$;

module.exports = {
  $el: $('<div class="block-overlay"></div>'),
  block: function(){
    $('body').append(this.$el);
    this.$el.addClass('is-blocked');
    this.$el.velocity('fadeIn');
    $('body').addClass('is-blocked');
  },
  unblock: function(){
    this.$el.removeClass('is-blocked').remove();
    $('body').height('auto').removeClass('is-blocked');
  }
};



//////////////////
// WEBPACK FOOTER
// ./source/scripts/global/ui-block.js
// module id = 22
// module chunks = 0 1